export const SELECT_DEFAULT_PLACEHOLDER = 'Выберите из списка';
export const SELECT_ITEM_LIST_HEIGHT_MAX_DEFAULT = 200;
